import React from "react"
import debounce from "debounce"
import { fetchUserProjects, fetchProject } from "../../util/project_api_util"
import VirtualStagingOrderModal from "./virtual_staging_order_modal_container"
import ScrollArrows from "../scroll_arrows"

export default class DashboardVirtualStagingModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      projects: [],
      search: "",
      selectedProjectId: null,
      selectedProject: null,
      loading: true,
      searching: false,
      fetchingProject: false,
    }
    this.handleNext = this.handleNext.bind(this)
    this.handleSearchChange = this.handleSearchChange.bind(this)
    this.debouncedSearch = debounce((term) => this.fetchSearch(term), 800)
    this.projectListRef = React.createRef()
  }

  userId() {
    return this.props.currentUser.roles?.admin ? "all-users" : this.props.currentUser.id
  }

  componentDidMount() {
    document.body.style.overflow = "hidden"
    // completed_stream_amount: 4 → 5*4 = 20 recent complete projects + any non-complete
    fetchUserProjects(this.userId(), null, null, false, 4).then(projects => {
      const list = Array.isArray(projects) ? projects : Object.values(projects)
      this.setState({ projects: list, loading: false })
    })
  }

  componentWillUnmount() {
    document.body.style.overflow = "unset"
    this.debouncedSearch.clear()
  }

  fetchSearch(term) {
    fetchUserProjects(this.userId(), term).then(projects => {
      const list = Array.isArray(projects) ? projects : Object.values(projects)
      this.setState({ projects: list, searching: false })
    })
  }

  handleSearchChange(e) {
    const term = e.target.value
    this.setState({ search: term, selectedProjectId: null })

    if (term.length >= 3) {
      this.setState({ searching: true })
      this.debouncedSearch(term)
    } else if (term.length === 0) {
      this.debouncedSearch.clear()
      this.setState({ searching: false })
      // Reload the initial 20
      fetchUserProjects(this.userId(), null, null, false, 4).then(projects => {
        const list = Array.isArray(projects) ? projects : Object.values(projects)
        this.setState({ projects: list, searching: false })
      })
    } else {
      this.debouncedSearch.clear()
      this.setState({ searching: false })
    }
  }

  handleNext() {
    const { selectedProjectId, fetchingProject } = this.state
    if (!selectedProjectId || fetchingProject) return
    this.setState({ fetchingProject: true })
    fetchProject(selectedProjectId).then(response => {
      const project = Object.values(response)[0]
      this.setState({ selectedProject: project, fetchingProject: false })
    })
  }

  projectLabel(project) {
    const addr = project.address
    if (!addr) return `Project #${project.id}`
    if (addr.formatted_address) {
      return [project.title, addr.apartment_number, addr.formatted_address].filter(Boolean).join(" — ")
    }
    return [project.title, addr.street1, addr.city, addr.region].filter(Boolean).join(", ")
  }

  render() {
    const { onClose } = this.props
    const { projects, search, selectedProjectId, selectedProject, loading, searching, fetchingProject } = this.state

    if (selectedProject) {
      return (
        <VirtualStagingOrderModal
          project={selectedProject}
          onClose={onClose}
          onReloadProject={() => {}}
          onBack={() => this.setState({ selectedProject: null })}
        />
      )
    }

    return (
      <div className="modal-background">
        <div className="orderpreviewModal vsOrderModal" onClick={e => e.stopPropagation()}>
          <div className="orderPreviewModalComponent">
            <div className="vsOrderStepContent">
              <div className="contractorModalHeading">
                <div className="contractorModalDescription">Choose a listing for virtual staging</div>
                <div className="closeIcon" style={{ fontSize: "20px" }} onClick={onClose}>
                  <i className="fas fa-times" />
                </div>
              </div>
              <div className="vsOrderScreen">
                <div className="vsDashboardSelectStep">
                  <input
                    className="vsDashboardSearchInput"
                    type="text"
                    placeholder="Search by address..."
                    value={search}
                    onChange={this.handleSearchChange}
                    autoFocus
                  />
                  <div className="scrollEdgeWrapper">
                    <div className="vsDashboardProjectList" ref={this.projectListRef}>
                      {(loading || searching) && (
                        <div className="vsDashboardProjectEmpty">
                          {loading ? "Loading projects…" : "Searching…"}
                        </div>
                      )}
                      {!loading && !searching && projects.length === 0 && (
                        <div className="vsDashboardProjectEmpty">No projects found</div>
                      )}
                      {!loading && !searching && projects.map(p => (
                        <div
                          key={p.id}
                          className={`vsDashboardProjectItem${p.id === selectedProjectId ? " vsDashboardProjectItemSelected" : ""}`}
                          onClick={() => this.setState({ selectedProjectId: p.id })}
                        >
                          {this.projectLabel(p)}
                        </div>
                      ))}
                    </div>
                    <ScrollArrows scrollRef={this.projectListRef} />
                  </div>
                </div>
                <div className="vsOrderFooter" style={{ borderTop: "none" }}>
                  {this.props.currentUser?.roles?.admin ? (
                    <a
                      href="/create-virtual-suite"
                      style={{ fontSize: "12px", color: "#888", textDecoration: "underline", alignSelf: "center" }}
                    >
                      Using external photos?
                    </a>
                  ) : <div />}
                  <button
                    className="projectEditButton projectEditButtonPrimary vsOrderFooterBtn"
                    onClick={this.handleNext}
                    style={{ opacity: selectedProjectId ? 1 : 0.4, cursor: selectedProjectId ? "pointer" : "default" }}
                  >
                    {fetchingProject ? "Loading…" : "Next →"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
